"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _Agent_defaultHttpAgent, _Agent_defaultHttpsAgent;
Object.defineProperty(exports, "__esModule", { value: true });
const agentkeepalive_1 = __importDefault(require("agentkeepalive"));
class Agent {
    constructor(agentOpts) {
        _Agent_defaultHttpAgent.set(this, void 0);
        _Agent_defaultHttpsAgent.set(this, void 0);
        __classPrivateFieldSet(this, _Agent_defaultHttpAgent, new agentkeepalive_1.default(agentOpts), "f");
        __classPrivateFieldSet(this, _Agent_defaultHttpsAgent, new agentkeepalive_1.default.HttpsAgent(agentOpts), "f");
    }
    getAgent(url) {
        if (url.startsWith('https:')) {
            return __classPrivateFieldGet(this, _Agent_defaultHttpsAgent, "f");
        }
        else if (url.startsWith('http:')) {
            return __classPrivateFieldGet(this, _Agent_defaultHttpAgent, "f");
        }
        else {
            throw new Error('Unknown protocol');
        }
    }
}
exports.default = Agent;
_Agent_defaultHttpAgent = new WeakMap(), _Agent_defaultHttpsAgent = new WeakMap();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiZmlsZTovLy9ob21lL2hicC9yZXBvcy9mZXRjaC9zcmMvYWdlbnQtd3JhcHBlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7OztBQUVBLG9FQUF1QztBQUd2QyxNQUFxQixLQUFLO0lBSXpCLFlBQVksU0FBdUI7UUFIbkMsMENBQThCO1FBQzlCLDJDQUFnQztRQUcvQix1QkFBQSxJQUFJLDJCQUFxQixJQUFJLHdCQUFTLENBQUMsU0FBUyxDQUFDLE1BQUEsQ0FBQztRQUVsRCx1QkFBQSxJQUFJLDRCQUFzQixJQUFJLHdCQUFTLENBQUMsVUFBVSxDQUFDLFNBQVMsQ0FBQyxNQUFBLENBQUM7SUFDL0QsQ0FBQztJQUVELFFBQVEsQ0FBQyxHQUFXO1FBQ25CLElBQUksR0FBRyxDQUFDLFVBQVUsQ0FBQyxRQUFRLENBQUMsRUFBRTtZQUM3QixPQUFPLHVCQUFBLElBQUksZ0NBQW1CLENBQUM7U0FDL0I7YUFBTSxJQUFJLEdBQUcsQ0FBQyxVQUFVLENBQUMsT0FBTyxDQUFDLEVBQUU7WUFDbkMsT0FBTyx1QkFBQSxJQUFJLCtCQUFrQixDQUFDO1NBQzlCO2FBQU07WUFDTixNQUFNLElBQUksS0FBSyxDQUFDLGtCQUFrQixDQUFDLENBQUM7U0FDcEM7SUFDRixDQUFDO0NBQ0Q7QUFuQkQsd0JBbUJDIn0=